import { createTheme } from "@mui/material/styles";

import { nucTokens } from "./tokens";

export const theme = createTheme({
  palette: {
    primary: {
      main: nucTokens.cyan,
    },
    secondary: {
      main: "#19857b",
    },
    gray: {
      main: "#e0e0e0",
    },
    light: {
      main: "#f4f4f4",
    },
    buttonAction: {
      main: "#454746",
    },
    // Design tokens (src/scss/_tokens.scss), reachable as theme.palette.nuc
    // and in sx as "nuc.ink". Typography stays on the MUI default until the
    // refreshed surfaces move onto MUI components (#2637).
    nuc: nucTokens,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1300,
      xxl: 1536,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
      variants: [
        {
          props: { size: "condensed" },
          style: {
            padding: "1px 8px",
            paddingTop: "1px",
          },
        },
      ],
    },
  },
});
